import axios, { AxiosPromise } from 'axios';

import { IMarket } from '../../../@types/model/masterData/market/market';

export default class MarketHttpService {
    public static getMarketData() : AxiosPromise<Array<IMarket>> {
        return axios.get(`${API_URL}/v1/Market/GetAllWeb`);
    }

    public static addOrUpdateMarket(data : IMarket) : AxiosPromise<IMarket> {
        return axios.post(`${API_URL}/v1/Market/PostMarket`, data);
    }

    public static deleteMarket(marketId : number) : AxiosPromise<IMarket> {
        return axios.delete(`${API_URL}/v1/Market/Delete`, {
            params : { marketId },
        });
    }
}
